module.exports = __webpack_public_path__ + "img/626b9fd680a65.3f22670c.png";